var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductT4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29102 4.85205H10.0081L12.2791 16.0706",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5898 12.0864H27.9947",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9783 32.7456C18.583 32.7456 22.3159 29.0127 22.3159 24.408C22.3159 19.8032 18.583 16.0703 13.9783 16.0703C9.37352 16.0703 5.64062 19.8032 5.64062 24.408C5.64062 29.0127 9.37352 32.7456 13.9783 32.7456Z",
    fill: "url(#paint0_linear_7153_14033)",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.979 28.5019C16.2401 28.5019 18.0732 26.6689 18.0732 24.4077C18.0732 22.1465 16.2401 20.3135 13.979 20.3135C11.7178 20.3135 9.88477 22.1465 9.88477 24.4077C9.88477 26.6689 11.7178 28.5019 13.979 28.5019Z",
    fill: "url(#paint1_linear_7153_14033)",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8147 32.2398C34.6853 32.2398 36.2017 30.7234 36.2017 28.8528C36.2017 26.9822 34.6853 25.4658 32.8147 25.4658C30.9441 25.4658 29.4277 26.9822 29.4277 28.8528C29.4277 30.7234 30.9441 32.2398 32.8147 32.2398Z",
    fill: "url(#paint2_linear_7153_14033)",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.623 12.0674H22.4068C26.3388 12.0674 27.4743 18.0692 27.4743 18.0692",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6875 27.0685L38.4451 25.4658",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 18.7046H28.9744C30.6939 18.7046 32.0824 20.0996 32.0824 21.8126L32.8091 28.7422",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4609 24.8359L14.5056 24.0703",
    stroke: "white",
    strokeWidth: 1.72268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_14033",
    x1: -3.58358,
    y1: 36.9171,
    x2: 24.8009,
    y2: 18.9804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14033",
    x1: 2.84661,
    y1: 24.6433,
    x2: 18.6075,
    y2: 23.2508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7153_14033",
    x1: 26.2251,
    y1: 31.657,
    x2: 34.8617,
    y2: 27.6234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.0681,
    height: 30.3923,
    fill: "white",
    transform: "translate(4.4668 4.18701)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductT4);
export default __webpack_public_path__ + "static/media/product-t4.0a70f04c3dc2a717b47f7be219555da7.svg";
export { ForwardRef as ReactComponent };